import {createLazyFileRoute} from '@tanstack/react-router'

import Login from '@/views/auth/SignIn/SignIn'

export const Route = createLazyFileRoute('/auth/sign-in')({
  component: Login,
})
